export enum SubscriptionTypeEnum {
  Free = "Free",
  Paid = "Paid",
  Trial = "Trial",
}
